import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { NDDDialogService } from '@ndk/ng-dialog';

import { BrowserTypes } from '@core/check-browser/browser.enum';
import { CheckBrowserService } from '@core/check-browser/check-browser.service';
import { ReportRouter } from '@core/routers/report-router.enum';

@Injectable({
    providedIn: 'root',
})
export class ReportCheckIEBrowserGuardService implements CanActivate {
    constructor(
        @Inject(Window) private window: Window,
        private router: Router,
        private dialogService: NDDDialogService,
        private checkBrowserService: CheckBrowserService,
    ) { }

    public canActivate(): boolean {
        // Valida se o navegador é o IE para bloquear o acesso
        if (this.checkBrowserService.checkBrowserIs(BrowserTypes.IE)) {
            // Caso acessado diretamente a rota dos relatórios direciona para forbidden
            if (this.window.location.pathname.includes(`/${ ReportRouter.NewReports }`)) {
                this.router.navigate(['page-forbidden']);
            } else { // Caso acessado pelo menu, apresenta a mensagem e impede a navegação
                this.dialogService.alert({ message: '360ReportsBrowserNotSupported' });
            }

            return false;
        }

        return true;
    }
}
